__webpack_require__.p = "/planungstool/";